import React, { Fragment, useEffect } from "react";

// ** Router Import
import { prepareBlobUrl, setLocalData } from "./helperFunctions";
import AllRoutes from "./routes/allRoutes";

// THIRD - PARTY IMPORT
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";

import { FINGER_KEY, FINGER_REGION_KEY, restricForFingerPrintUrls } from "./constant";
import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
import { setVisiterId, useVisiterId } from "./redux/slices/authSlice";
import { useDispatch } from "react-redux";

const App = () => {
  const logo = process.env.REACT_APP_FAVICON;
  const dispatch = useDispatch();
  const visiterId = useVisiterId()
  
  const getFingerprint = async () => {
    let fp;

    try {
      fp = await FingerprintJS.load({
        apiKey: FINGER_KEY,
        region: FINGER_REGION_KEY,
      });

    } catch (error) {
      try {
        fp = await FingerprintJS.load({
          apiKey: FINGER_KEY,
          region: FINGER_REGION_KEY,
          scriptUrlPattern: "/fingerprint-loader.js",
        });

      } catch (fallbackError) {
        console.error("Both FingerprintJS loads failed:", fallbackError);
        return;
      }
    }

    try {
      const result = await fp.get();
      if (
        !restricForFingerPrintUrls?.find?.((item) =>
          window.location.hostname?.includes?.(item)
        )
      ) {
        if (result?.visitorId) {
          dispatch(setVisiterId(result?.visitorId))
          setLocalData("b", { visitorId: result?.visitorId }, {});
        }
      }
    } catch (err) {
      console.error("Failed to get visitor ID:", err);
    }
  };

  useEffect(() => {
    if (!visiterId?.length) {
      getFingerprint();
    }
  }, [visiterId]);

  return (
    <Fragment>
      <Helmet>
        <link rel="icon" type="image/svg+xml" href={prepareBlobUrl(logo)} />
      </Helmet>
      <AllRoutes />
      <Toaster />
    </Fragment>
  );
};

export default App;
